var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 18.0022V14.1861C30 9.31858 30 6.88468 28.6709 5.23633C28.4024 4.90333 28.099 4.59988 27.766 4.33138C26.1175 3.00223 23.6838 3.00223 18.8163 3.00223C17.7579 3.00223 17.2288 3.00223 16.7442 3.17323C16.6434 3.20893 16.5447 3.24973 16.4482 3.29593C15.9846 3.51763 15.6105 3.89173 14.8622 4.64008L7.7574 11.745C6.89025 12.612 6.45675 13.0456 6.2283 13.5969C6 14.1481 6 14.7613 6 15.9876V21.0022C6 26.6592 6 29.4876 7.7574 31.2449C9.34605 32.8337 11.8102 32.9861 16.4482 33.0007M16.5 3.75223V4.50223C16.5 8.74498 16.5 10.8663 15.1819 12.1843C13.8639 13.5022 11.7426 13.5022 7.5 13.5022H6.75",
    stroke: "#212129",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 27H19M25 21V33",
    stroke: "#212129",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.2a1ba0d065ee1aaeb6e7e7f2ab8b786e.svg";
export { ForwardRef as ReactComponent };